import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';

import { Sprint } from './Sprint';

function CreateSprint({ type = 'button' }: { type?: string }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {type === 'button' ? (
        <Button onClick={onOpen} className="h-36 mt-3" status="primary">
          <span className="block">
            <AddIcon size={10} wrapperClass="mt-2 mr-2" /> New sprint
          </span>
        </Button>
      ) : (
        <button
          className="block w-full border-dashed border border-primary-500 bg-primary-100 text-primary-500 rounded-md px-16 py-8 mr-8 font-medium text-sm"
          onClick={onOpen}
        >
          <span className="block">
            <AddIcon size={14} wrapperClass="mt-2 mr-2" /> Create a sprint
          </span>
        </button>
      )}
      <Portal>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            style={{
              position: 'initial',
              margin: '80px',
            }}
            className={` min-w-356 bg-white rounded-lg static`}
          >
            <div>
              <Sprint onClose={onClose} />
            </div>
            <ModalCloseButton />
          </ModalContent>
        </Modal>
      </Portal>
    </>
  );
}

export default CreateSprint;
